import React from "react";
import {
    COUNTERPARTY_REVIEW_FIELD_LABELS,
    CounterpartyReviewField,
} from "@common/types/counterpartyFieldReview";
import { CounterpartyTinReview } from "@common/schemas/counterpartyTin.schema";
import { WorkspaceMember } from "@common/types/workspace";
import {
    CounterpartyTinIds,
    useCounterpartyTinQuery,
} from "@api/counterpartyTin.api";
import { useCanManageCounterpartyTin } from "@components/counterparty/tin/useCanManageCounterpartyTin";
import { useTinReviewActions } from "@components/counterparty/tin/useTinReviewActions";
import { ReviewRow } from "./CounterpartyDetailsReview";
import { toFieldReviewer } from "./toFieldReviewer";

interface Props {
    ids: CounterpartyTinIds;
    currentUserId: number;
    members: WorkspaceMember[];
}

interface LoadedProps extends Props {
    tinRevisionId: string;
    reviews: CounterpartyTinReview[];
}

const LoadedTinReviewRow: React.FC<LoadedProps> = ({
    ids,
    tinRevisionId,
    reviews,
    currentUserId,
    members,
}) => {
    const { markReviewed, undoReview, isPending } = useTinReviewActions({
        ids,
        tinRevisionId,
    });

    return (
        <ReviewRow
            label={
                COUNTERPARTY_REVIEW_FIELD_LABELS[CounterpartyReviewField.TIN]
            }
            reviewers={reviews.map((review) =>
                toFieldReviewer(review, members),
            )}
            currentUserId={currentUserId}
            onMarkReviewed={markReviewed}
            onUndoReview={undoReview}
            isDisabled={isPending}
        />
    );
};

export const CounterpartyTinReviewRow: React.FC<Props> = (props) => {
    const canManageTin = useCanManageCounterpartyTin();
    const tinQuery = useCounterpartyTinQuery({
        ids: props.ids,
        enabled: canManageTin,
    });

    if (!canManageTin || !tinQuery.data?.tinRevisionId) {
        return null;
    }

    return (
        <LoadedTinReviewRow
            {...props}
            tinRevisionId={tinQuery.data.tinRevisionId}
            reviews={tinQuery.data.reviews}
        />
    );
};
